<div class="e-invoice-sign-up" [class.full-width]="isFullWidth">
    <a href="#" (click)="openEInvoiceSignUpDialog($event)">
        {{ 'eInvoiceSignUp.SignUpButton' | translate }}
    </a>
</div>
